/* eslint-disable no-param-reassign */
// Redux Toolkit allows us to write "mutating" logic in reducers. It
// doesn't actually mutate the state because it uses the immer library,
// which detects changes to a "draft state" and produces a brand new
// immutable state based off those changes

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MetadataSettableType } from '../../types';

type MetadataStateType = {
    metadataOrder: MetadataSettableType,
    metadataTenant: MetadataSettableType,
    fetchingForTenant: boolean,
    fetchingForOrder: boolean
};

const emptyMetada: MetadataSettableType = {
    vehicleTypes: [],
    equipment: [],
    sustainability: [],
    licencesCertificates: [],
    customLicencesCertificates: []
};

const initialState: MetadataStateType = {
    metadataOrder: emptyMetada,
    metadataTenant: emptyMetada,
    fetchingForTenant: false,
    fetchingForOrder: false
};

const slice = createSlice({
    name: 'metadata',
    initialState,
    reducers: {
        fetchForTenant: (state) => {
            state.fetchingForTenant = true;
        },
        fetchedForTenant: (state, action: PayloadAction<{ data: MetadataSettableType }>) => {
            state.metadataTenant = action.payload.data;
            state.fetchingForTenant = false;
        },
        fetchForOrder: (state) => {
            state.fetchingForOrder = true;
        },
        fetchedForOrder: (state, action: PayloadAction<{ data: MetadataSettableType }>) => {
            state.metadataOrder = action.payload.data;
            state.fetchingForOrder = false;
        }
    }
});

export default slice;
